// extracted by mini-css-extract-plugin
export default {"root":"root__root____Ymey","rootAvoidOverflow":"root__rootAvoidOverflow___F60b0","bg-grey":"root__bg-grey___N6n_l","bgGrey":"root__bg-grey___N6n_l"};